import {Row} from 'react-table'

type Props<T extends object> = {
  row: Row<T>
}

const CustomRow = <T extends object>({row}: Props<T>) => (
  <tr {...row.getRowProps()}>
    {row.cells.map((cell) => {
      return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
    })}
  </tr>
)

export {CustomRow}
